<template>
	<div class="">
		<DynamicMultiplier
			name="PaymentReceipt"
			state="paymentData"
			stateKey="payments"
		/>
		<BaseButton
			class="btn btn-primary form-control form-control-lg"
			type="submit"
			label="Save payment"
			@on:Click="addLeadPayment()"
		/>
	</div>
</template>
<script>
	import { provide, reactive, inject } from "vue";
	import DynamicMultiplier from "./DynamicMultiplier.vue";
	import BaseButton from "./BaseButton.vue";
	import toast from "@/config/toast";
	import API from "@/config/api";

	export default {
		name: "PaymentMultiplier",

		components: {
			DynamicMultiplier,
			BaseButton,
		},

		setup: () => {
			const masterStore = inject("masterStore");

			let paymentData = reactive({
				payments: [],
			});

			provide("paymentData", paymentData);

			const addLeadPayment = async () => {
				try {
					await API.privateRequest.patch(
						`leads/${masterStore.state.data._id}`,
						paymentData,
					);
					masterStore.methods.changeData({...masterStore.state.data, payments: [ ...paymentData.payments ]})
					toast.success(
						{ message: "Receipt Added!", position: "topRight" },
						true,
					);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}
					console.log("error => ", err);
					toast.error(message, true);
				}
			};

			if (
				masterStore.state.data?.payments &&
				masterStore.state.data.payments instanceof Array &&
				masterStore.state.data.payments.length
			) {
				paymentData.payments = masterStore.state.data.payments;
			}

			return {
				paymentData,
				addLeadPayment,
			};
		},
	};
</script>
